import { render, staticRenderFns } from "./PersonProfileAssociatedPersonDetails.vue?vue&type=template&id=67789db9&scoped=true&"
import script from "./PersonProfileAssociatedPersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAssociatedPersonDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileAssociatedPersonDetails.vue?vue&type=style&index=0&id=67789db9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67789db9",
  null
  
)

export default component.exports